<template>
  <div class='basicinfomation'>
    <div class="top">
      修改密码
    </div>
    <div class="body">
      <el-form
        :model="ruleForm"
        status-icon
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item
          label="旧密码"
          prop="oldpassword"
        >
          <el-input
            v-model="ruleForm.oldpassword"
            class="pwinput"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="新密码"
          prop="password"
        >
          <el-input
            type="password"
            v-model="ruleForm.password"
            autocomplete="off"
            class="pwinput"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="确认密码"
          prop="checkPass"
        >
          <el-input
            type="password"
            v-model="ruleForm.checkPass"
            autocomplete="off"
            class="pwinput"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            @click="submitForm('ruleForm')"
          >提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import Api from '../../api/index'

export default {
  data () {
    var checkoldpw = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入旧密码'));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'));
      } else {
        if (this.ruleForm.checkPass !== '') {
          this.$refs.ruleForm.validateField('checkPass');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入新密码'));
      } else if (value !== this.ruleForm.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        password: '',
        checkPass: '',
        oldpassword: ''
      },
      rules: {
        password: [
          { validator: validatePass, trigger: 'blur' }
        ],
        checkPass: [
          { validator: validatePass2, trigger: 'blur' }
        ],
        oldpassword: [
          { validator: checkoldpw, trigger: 'blur' }
        ]
      }
    }
  },
  created () {
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const userid = JSON.parse(window.sessionStorage.getItem('userinfo'))
          delete this.ruleForm.checkPass
          this.ruleForm.userid = userid.userid
          const res = await Api.userinfo.ChangePassword(this.ruleForm)
          if (res.success != true) return this.$Message.info(res.msg)
          this.$Message.success(res.msg)
          localStorage.clear()
          sessionStorage.clear()
          const that = this
          setTimeout(function () {
            that.$router.push('/')
          }, 1000)
        } else {
          return false;
        }
      });
    },
  }
}
</script>
<style lang='less' scoped>
.basicinfomation {
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 0px 20px;
  .top {
    width: 100%;
    padding: 10px 20px 0 20px;
    border-bottom: 1px solid #ccc;
    height: 40px;
    font-size: 15px;
    font-weight: 600;
  }
  .body {
    padding: 20px;
    /deep/.pwinput {
      width: 400px;
    }
    .userInfo {
      width: 500px;
    }
  }
}
</style>